export enum AppointmentStatusEnum {
	Pending = 'Pending',
	Confirmed = 'Confirmed',
	InProgress = 'InProgress',
	Ended = 'Ended',
}
